module.exports = __webpack_public_path__ + "media/npc-bubble.d19cca22.mp3";